import { DownloadModalData } from './download-modal/download-modal.component';

export interface ActivationCreateHandoffContext {
  source: 'activation_journey';
  returnRoute: '/setup/first-employee';
}

export interface CreateUserDialogData {
  isUserEditable: boolean;
  editUserId?: number | string | null;
  fromProfileScreen?: boolean;
  isRedirect?: boolean;
  activationHandoff?: ActivationCreateHandoffContext;
}

export interface CreatedEmployeePayload {
  employeeId: number;
  name: string;
  email: string;
  versionType: DownloadModalData['versionType'];
  operatingSystem: DownloadModalData['operatingSystem'];
  sendEmail: boolean;
  firstName: string;
  lastName: string;
  /** Transient in-memory only — never persist in journey/session storage. */
  installerPassword?: string;
}

export type CreateUserDialogResult =
  | { reason: 'cancel' }
  | { reason: 'edit_success'; updated: true }
  | { reason: 'create_success'; employee: CreatedEmployeePayload };

export interface DownloadModalCloseResult {
  reason: 'closed';
  autoDownloadAttempted: boolean;
  downloadTriggered: boolean;
}

export function mapVersionTypeToActivationMode(
  versionType: CreatedEmployeePayload['versionType']
): 'employee_controlled' | 'admin_controlled' | 'hidden' {
  if (versionType === 'restricted') {
    return 'admin_controlled';
  }
  if (versionType === 'silent') {
    return 'hidden';
  }
  return 'employee_controlled';
}

export function mapSendEmailToActorRoute(
  sendEmail: boolean
): 'employee_runs' | 'hero_installs' {
  return sendEmail ? 'employee_runs' : 'hero_installs';
}
